import { render, staticRenderFns } from "./PendingApprovalWorkOrderDialog.vue?vue&type=template&id=4858376c"
import script from "./PendingApprovalWorkOrderDialog.vue?vue&type=script&lang=ts"
export * from "./PendingApprovalWorkOrderDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports